const config = (zoom = 12, center = { lat: 51.647573, lng: 5.201691 }) => {
    return {
        zoom: zoom,
        center: center,
        /* based on first location will be overruled by fitbounds */
        zoomControl: true,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapId: "5ebeed773717bd034ffe34f2",
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
    };
};

export default config;
